<div class="dialog-wrapper">
  <h1 mat-dialog-title>Mehrere Dokumente auswählen</h1>
  <div mat-dialog-content>
    <gsm-drag-drop-dokument-picker
      [documentTypes]="data?.documentTypes"
      [acceptedFileTypes]="acceptedFileTypes"
      (update)="onDocumentsUpdate($event)"
    >
    </gsm-drag-drop-dokument-picker>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-raised-button color="primary" [mat-dialog-close]="documents" [disabled]="!formValid">
      Dokumente hinzufügen
    </button>
    <button mat-button (click)="onCancelClick()">Abbrechen</button>
  </div>
</div>
